import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './configureStore';

export interface AlertMessage {
    id: number;
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
}

export interface AlertState {
    alerts: AlertMessage[];
}
const initialState: AlertState = {
    alerts: [],
};

export const alertSlice = createSlice({
    name: 'alertSlice',
    initialState,
    reducers: {
        addAlert: (state, action: PayloadAction<Omit<AlertMessage, 'id'>>) => {
            if (!state.alerts.some((alert) => alert.message === action.payload.message)) {
                state.alerts.push({ id: Date.now() + state.alerts.length, ...action.payload });
            }
        },
        removeAlertByID: (state, action: PayloadAction<number>) => {
            state.alerts = state.alerts.filter((alert) => alert.id !== action.payload);
        },
        removeAlertByType: (state, action: PayloadAction<'success' | 'error' | 'info' | 'warning'>) => {
            state.alerts = state.alerts.filter((alert) => alert.type !== action.payload);
        },
        removeAlerts: (state) => {
            state.alerts = [];
        },
    },
});

export const selectState = (state: RootState) => state.alertSlice;
export const selectAlerts = createSelector(selectState, (state) => state.alerts);

export const { addAlert, removeAlertByID, removeAlertByType, removeAlerts } = alertSlice.actions;
